import { Video } from 'lucide-react'
import { Seo } from '@/components/seo'
import { PageLayout } from '@/components/layout/page-layout'
import { ToolPageLayout } from '@/components/tools/tool-page-layout'
import { VideoPanel } from '@/features/video/video-panel'
import { useI18n } from '@/lib/i18n'

export default function VideoConverterPage() {
  const { t } = useI18n()

  return (
    <PageLayout>
      <Seo
        title={t('seoVideoTitle')}
        description={t('seoVideoDesc')}
        keywords={t('seoVideoKw').split(',').map((item) => item.trim())}
      />
      <ToolPageLayout
        icon={Video}
        title={t('toolPageVideo')}
        description={t('toolPageVideoDesc')}
        formats={['MP4', 'MOV', 'MKV', 'WEBM']}
      >
        <VideoPanel />
      </ToolPageLayout>
    </PageLayout>
  )
}